import { render } from "./ConsiliaDetailArticle.vue?vue&type=template&id=5bb0803c&scoped=true"
import script from "./ConsiliaDetailArticle.vue?vue&type=script&lang=js"
export * from "./ConsiliaDetailArticle.vue?vue&type=script&lang=js"

import "./ConsiliaDetailArticle.vue?vue&type=style&index=0&id=5bb0803c&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb0803c"]])

export default __exports__